/**
 * Created by Andrey Popov on 07.08.26
 */

const InviteFriendsConfig = {
    SLOTS: [
        { units: { code: "worker", stage: 3 } },
        { units: { code: "sacks", stage: 2 } },
        { units: { type: "reschest", stage: 0 } },
        { units: { code: "herochest", stage: 1 } },
        { units: { code: "crystal", stage: 1 } },
        { units: { code: "freechest", stage: 1 } },
        { units: { code: "sacks", stage: 2 } },
        { units: { type: "reschest", stage: 0 } },
        { units: { code: "herochest", stage: 1 } },
        { units: { code: "magicplant", stage: 4 } },
        { units: { code: "worker", stage: 4 } },
        { units: { code: "crystal", stage: 1 } }
    ]
};
